import React, { useState, useEffect } from "react";
import {
  FilterIconRent,
} from "../../AssetComponents/Images";
import { PurpleButton } from "../../Components/Buttons/PurpleButton";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import "react-range-slider-input/dist/style.css";
import {
  setPriceRange,
  setAmenities,
  setPropertyType,
  setInstantBook,
  setAllowPets
} from "../../ReduxSlices/SearchSlice";
import { BlackButton } from "../../Components/Buttons/BlackButton";

import { PriceRangeSection } from "../../Components/Rent/FilterPriceRangeSection";
import { FilterButton } from "../../Components/Rent/FilterButton";
import { BedroomFilter } from "../../Components/Rent/BedroomFilter";
import { BedFilter } from "../../Components/Rent/BedFilter";
import { BathroomFilter } from "../../Components/Rent/BathroomFilter";
import { PropertyTypeFilter } from "../../Components/Rent/PropertyTypeFilter";
import { BookingOptions } from "../../Components/Rent/BookingOptions";
import FilterAmenities from "../../Components/Rent/FilterComponents/FilterAmenities ";

import { FilterHeader } from "../../Components/Rent/FilterHeader";
import { FilterModal } from "../../Components/Rent/FilterModal";
import { useOnboarding } from './OnBoarding1';

export const Filter1 = ({ properties, onFilterChange, currentSortType }) => {
  // Redux state
  const reservation_period = useSelector((state) => state.reservation.period);
  const who = useSelector((state) => state.reservation.who);
  const guests = useSelector((state) => state.reservation.guests);
  const amenities = useSelector((state) => state.search.amenities);
  const propertyType = useSelector((state) => state.search.propertyType);
  const instantBook = useSelector((state) => state.search.instantBook);
  const allowPets = useSelector((state) => state.search.allowPets);
  const range = useSelector((state) => state.search.priceRange);
  
  // Local state
  const [openFilter, setOpenFilter] = useState(false);
  const [metaDetails, setMetaDetails] = useState({ amenities: {} });
  const [loading, setLoading] = useState(false);
  
  const dispatch = useDispatch();
  const { isOnboarding, currentStep } = useOnboarding();

  // Add highlighting during onboarding step 3 (filter step)
  const isHighlighted = isOnboarding && currentStep === 3;

  const applyAllFilters = async () => {
    // No logic - UI only
  };

  // Clear all filters
  const handleClear = () => {
    // No logic - UI only
  };

  // Price Range Effect - Updated to handle 10000 max
  useEffect(() => {
    // No logic - UI only
  }, [range, dispatch]);

  return (
    <div className="relative">
      <div
        onClick={() => setOpenFilter(true)}
        className={`${isHighlighted ? 'onboarding-highlight' : ''} py-[4px] cursor-pointer rounded-[10px] px-[14px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,257,0.8)] ${
          isHighlighted 
            ? 'bg-white border-2 border-purple-500 ring-4 ring-purple-300 animate-pulse' 
            : 'bg-white hover:bg-[#f6f6f6]'
        }`}
      >
        <FilterIconRent />
        <div className="text-[#5b1dee] font-semibold">Filters</div>
      </div>
      
      <FilterModal open={openFilter} onClose={() => setOpenFilter(false)}>
        <div className="w-[500px]">
          <FilterHeader />
          <div className="h-[50vh] overflow-auto scrollbarwidth px-[10px]">
            {/* Price Range Section */}
            <div className="w-full">
              <PriceRangeSection range={range} onRangeChange={() => {}} />
            </div>
            <div className="w-full h-[2px] bg-[#eeeeee] my-[12px]" />
            
            {/* Rooms and Beds Section */}
            <div className="space-y-[12px]">
              <div className="text-[18px] font-semibold">
                Rooms and beds
              </div>
              <BedroomFilter amenities={amenities} dispatch={dispatch} />
              <BedFilter amenities={amenities} dispatch={dispatch} />
              <BathroomFilter amenities={amenities} dispatch={dispatch} />                    
            </div>
            <div className="w-full h-[2px] bg-[#eeeeee] my-[12px]" />
            
            {/* Property Type Section */}
            <PropertyTypeFilter propertyType={propertyType} dispatch={dispatch} />
            <div className="w-full h-[2px] bg-[#eeeeee] my-[12px]" />
            
            {/* Booking Options Section */}
            <BookingOptions instantBook={instantBook} allowPets={allowPets} dispatch={dispatch} />
            <div className="w-full h-[2px] bg-[#eeeeee] my-[12px]" />

            {/* Amenities Section */}
            <div className="w-full space-y-[10px]">
              <FilterAmenities 
                selectedAmenities={metaDetails.amenities} 
                onAmenitiesChange={() => {}} 
              />
            </div>
          </div>
          
          {/* Filter Actions */}
          <div className="flex items-center justify-between mt-[32px]">
            <BlackButton 
              text="Clear" 
              onClick={() => {}} 
            />
            <PurpleButton
              text={loading ? "Applying..." : "Apply Filters"}
              onClick={() => {}}
              disabled={loading}
            />
          </div>
        </div>
      </FilterModal>
    </div>
  );
};

export default Filter1;